import React from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import IvoryList from "../../assets/icons/IvoryLogo.svg";
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../store/language-context';

const DeleteAccount = () => {
  const { t } = useTranslation();
  const { URL } = useLanguage();
  
  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    const confirm = await Swal.fire({
      title: t('profile.delete-title'),
      text: t('profile.delete-p'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t('profile.delete-action'),
      cancelButtonText: t('custom.cancel')
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(`${URL}/profile/destroy`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      Swal.fire({
        title: t('profile.done-delete'),
        text: t('custom.done'),
        icon: "success",
        confirmButtonText: t('custom.accept')
      });

      localStorage.removeItem("token");
      window.location.href = "/login";

    } catch (error) {


      Swal.fire({
        title: t('custom.err-title'),
        text: t('custom.err'),
        icon: "error",
        confirmButtonText: t('custom.accept')
      });
    }
  };

  return (
    <div className="form-container text-center mt-4">
      <h4 className=" flex items-center justify-center gap-2 " style={{ color: "#929292" }} >
        <img src={IvoryList} alt="list" className="me-2" />
        {t('profile.delete-text')}
      </h4>
      <button
        onClick={handleDelete}
        className="bg-[#6A2F38] text-white px-4 py-2 rounded mt-4">
        {t('profile.delete-text-2')}
      </button>
    </div>
  );
};

export default DeleteAccount;
